// extracted by mini-css-extract-plugin
export default {"app":"layout_app__AULcu","main":"layout_main__x19xl"};